import { MediaPlayerProxy } from "./media-player-proxy";
import { AMP } from "./globals";
import { OmnitureTracking } from "./tracking/omniture/omniture-tracking";
//import { HeartbeatTracking } from './tracking/heartbeat-2/heartbeat-tracking';
import MediaAnalyticsTracking from "./tracking/media-analytics/media-analytics-tracking";
import { TapForSoundPlugin } from "./amp-plugins/tap-for-sound/plugin";
import { AmpEventsSourcesPlugin } from "./amp-plugins/amp-events-sources/plugin";
import { debug } from "./utils/debug-log";
import "@medscape/streaming-video-player/src/sass/streaming-video-player.scss";
import { EVENT_READY as AMP_EVENTS_SOURCES_READY } from "./amp-plugins/amp-events-sources/amp-events-sources.constants";
import { getMediaConfig } from "./tracking/media-analytics/media-config";
const { Promise, setTimeout, clearTimeout } = window;
if (AMP.plugins.AmpEventsSources == null) {
  AMP.registerPlugin("AmpEventsSources", AmpEventsSourcesPlugin.create());
}

if (AMP.plugins.TapForSound == null) {
  AMP.registerPlugin("TapForSound", TapForSoundPlugin.create());
}

export class StreamingVideoPlayer extends MediaPlayerProxy {
  constructor(containerEl, playerSettings, trackingSettings) {
    super(containerEl, playerSettings, trackingSettings);
    this.videoId = null;
    this.isMuted = true;
    debug.log(
      "[StreamingVideoPlayer] StreamingVideoPlayer:\nContainer:\n",
      containerEl,
      "\nPlayer Settings:\n",
      playerSettings,
      "\nTracking Settings:\n",
      trackingSettings
    );
  }
  async create() {
    let { containerEl, el, ampConfig } = this;

    containerEl.appendChild(el);
    debug.log("[StreamingVideoPlayer] AmpConfig:", ampConfig);
    const mediaConfig = await getMediaConfig();
    try {
      const amp = await AMP.create(el, ampConfig);
      debug.log("[StreamingVideoPlayer] AMP.create:", amp);
      this.amp = amp;

      //containerEl.appendChild(el);

      // Fix issue with AMP setCurrentTime not working properly on first video
      // Might need to move this code to the SVP module
      //const { setCurrentTime } = amp;

      amp.setCurrentTime = function (time) {
        //const x = setCurrentTime.call(amp,time);
        if (amp.mediaElement) {
          amp.mediaElement.currentTime = time;
          return amp.mediaElement.currentTime;
        } else {
          return setCurrentTime.call(amp, time);
        }
      };
      if (amp.AmpEventsSources == null) {
        const promise = new Promise((resolve, reject) => {
          amp.addEventListener(AMP_EVENTS_SOURCES_READY, (e) => {
            this.init();

            resolve(amp);
          });
        });
        return promise;
      } else {
        this.init();

        return amp;
      }
    } catch (error) {
      debug.error("Error Creating AMP:", error);
      throw error;
    }
  }
  destroy() {
    debug.log("[StreamingVideoPlayer] destroy");
    this.handleAmpDestroy();
    this.amp.destroy();
  }
  destroySubscriptions() {
    this.subscriptions.forEach((subscription) => {
      if (subscription != null && subscription.unsubscribe != null) {
        subscription.unsubscribe();
      }
    });
    this.subscriptions = [];
  }
  destroyOmnitureTracking() {
    if (this.omnitureTracking != null) {
      debug.log("[StreamingVideoPlayer] Destroy Omniture Tracking");
      this.omnitureTracking.destroy();
      this.omnitureTracking = null;
    }
  }
  destroyMediaAnalyticsTracking() {
    if (this.mediaAnalyticsTracking != null) {
      this.mediaAnalyticsTracking.destroy();
      this.mediaAnalyticsTracking = null;
    }
  }
  handleAmpDestroy() {
    debug.log("[StreamingVideoPlayer] handleAmpDestroy");
    this.destroySubscriptions();
    this.destroyOmnitureTracking();
    this.destroyMediaAnalyticsTracking();
  }
  handleCaptionChange(eventData) {
    //debug.log("[StreamingVideoPlayer] handleCaptionChange:", eventData);
    // Prevent blank black caption box from whitespaces
    let { event: e, amp } = eventData;
    if (e.data && e.data.length > 0) {
      let { text } = e.data[0];
      const hasText = text.trim().length > 0;
      if (!hasText) {
        amp.container.classList.add("svp-cc-empty-text");
      } else {
        amp.container.classList.remove("svp-cc-empty-text");
      }
    }
  }
  init() {
    debug.log("[StreamingVideoPlayer] init");
    this.destroySubscriptions();
    let { amp, ampConfig } = this;
    let touchstartTimer = null;
    this.isMuted = ampConfig.muted;
    let controlsContainer = amp.container.querySelector(".amp-react");
    amp.addTransform(akamai.amp.TransformType.ERROR, (error) => {
      console.error(
        "[streaming-video-player](TransformType.Error) error:",
        error
      );

      console.error(
        "[streaming-video-player](TransformType.Error) amp.media:",
        amp.media
      );
      this.mediaAnalyticsTracking?.tracker?.trackError(error.message);
      if (amp.media.type !== "video/mp4") {
        const sources = amp.getSource();
        const mp4Source = sources.find((source) => {
          return source.type === "video/mp4";
        });
        if (mp4Source != null) {
          const media = Object.assign({}, amp.media, {
            autoplay: true,
            source: [mp4Source],
            src: mp4Source.src,
            type: mp4Source.type,
          });
          console.log(
            "[streaming-video-player](TransformType.Error) Loading MP4 - media:",
            media
          );
          amp.setMedia(media);
        }
      }
    });
    if (
      window.navigator.maxTouchPoints != null &&
      window.navigator.maxTouchPoints > 0 &&
      amp.plugins.indexOf("react") > -1
    ) {
      let touchstartTime = amp.react.config.autoHide * 1000;

      amp.container.addEventListener("touchstart", (e) => {
        clearTimeout(touchstartTimer);
        //amp.container.classList.add('amp-active');
        if (controlsContainer != null) {
          amp.container.classList.add("amp-active");
          amp.react.mode = "fixed";
          /*
                    controlsContainer.classList.add('amp-active');
                    controlsContainer.classList.remove('amp-idle');
                    */
        }
        touchstartTimer = setTimeout(() => {
          //amp.container.classList.remove('amp-active');
          if (controlsContainer != null) {
            amp.container.classList.remove("amp-active");
            amp.react.mode = "auto";
            /*
                        controlsContainer.classList.remove('amp-active');
                        controlsContainer.classList.add('amp-idle');
                        */
          }
        }, touchstartTime);
      });
    }
    // Desktop: toggle video play/pause on click
    if (
      window.navigator.maxTouchPoints != null &&
      window.navigator.maxTouchPoints === 0
    ) {
      debug.log(
        "[StreamingVideoPlayer] Add Toggle Play/Pause Click Event Listener"
      );
      amp.mediaElement.addEventListener("click", (e) => {
        debug.log("[StreamingVideoPlayer] amp.mediaElement Clicked, Event:", e);
        const { buffering } = amp;
        const { paused } = amp.mediaElement;
        if (buffering === true) {
          return;
        } else if (paused === false) {
          amp.pause();
        } else {
          amp.play();
        }
      });
    }
    // PPE-407866: update tap for sound - unmute
    if (this.isMuted === true) {
      const unmute = function (e) {
        e.stopImmediatePropagation();
        amp.unmute();
        amp.mediaElement.removeEventListener("click", unmute, true);
      };
      amp.mediaElement.addEventListener("click", unmute, true);
    }
    
    this.initSubscriptions();
    this.initTracking();

    this.el.svp = this;
  }
  initSubscriptions() {
    let { amp } = this;
    debug.log("[StreamingVideoPlayer](initSubscriptions) amp.AmpEventsSources:",amp.AmpEventsSources);
    let autoplayblocked$ = amp.AmpEventsSources["autoplayblocked"].subscribe(
      (eventData) => {
        debug.warn(
          "[StreamingVideoPlayer] EVENT - Autoplay Blocked:",
          eventData
        );
        let { amp } = eventData;
        let mutechange$ = amp.AmpEventsSources["mutechange"].subscribe(
          (eventData) => {
            mutechange$.unsubscribe();
            amp.play();
          }
        );
        amp.mute();
      }
    );
    // Fix Start Time Defect in AMP
    let allowStartTime = true;
    debug.log("[StreamingVideoPlayer](initSubscriptions) subscribe loadeddata");
    let loadeddata$ = amp.AmpEventsSources["loadeddata"].subscribe(
      (eventData) => {
        debug.log(
          "[StreamingVideoPlayer] EVENT - %cLoaded Data:",
          "color: yellow;",
          "\n",
          eventData
        );
        const { amp } = eventData;
        const { startTime } = amp.media.metadata;
        if (allowStartTime && startTime && startTime > 0) {
          debug.warn(
            "[StreamingVideoPlayer] AMP BUGFIX: Fix Start Time Defect",
            startTime
          );
          amp.setCurrentTime(startTime);
          allowStartTime = false;
        }
      }
    );
    debug.log("[StreamingVideoPlayer](initSubscriptions) subscribe mediachange");

    let mediachange$ = amp.AmpEventsSources.mediachange.subscribe(
      (eventData) => {
        debug.log(
          "[StreamingVideoPlayer] %cMedia Changed:",
          "color: yellow;",
          "\n",
          eventData
        );
        let { amp } = eventData;
        // Replay triggers mediachange. Prevent creating nwe instace of OmnitureTracking
        if (eventData.videoId != this.videoId) {
          this.initOmnitureTracking();
        } else {
          // BUGFIX: amp mutes the video on replay
          if (amp.muted === false) {
            let mute$ = amp.AmpEventsSources["mutechange"].subscribe(
              (eventData) => {
                mute$.unsubscribe();
                debug.log(
                  "[StreamingVideoPlayer] MediaChange MuteChange Unmute"
                );
                amp.unmute();
              }
            );
            let playing$ = amp.AmpEventsSources["playing"].subscribe(
              (eventData) => {
                mute$.unsubscribe();
                playing$.unsubscribe();
              }
            );
          }
        }
        //this.initMediaAnalyticsTracking();
        this.videoId = eventData.videoId;
      }
    );

    let mutechange$ = amp.AmpEventsSources["mutechange"].subscribe(
      (eventData) => {
        debug.log(
          "[StreamingVideoPlayer] EVENT - mutechange",
          eventData.state.isMuted
        );
        this.lastEventState = eventData.state;
        if (eventData.state.isMuted == false) {
          // Flag that autoplay videos don't need to be muted anymore
          this.isUserUnmuted = true;
        }
      }
    );

    let captionCueChange$ = amp.AmpEventsSources[
      "captioningcuechange"
    ]?.subscribe((eventData) => {
      this.handleCaptionChange(eventData);
    });
    debug.log("[StreamingVideoPlayer](initSubscriptions) subscribe destroy");
    let destroy$ = amp.AmpEventsSources["destroy"].subscribe((eventData) => {
      debug.log("[StreamingVideoPlayer] Destroy SVP!", eventData);
      this.lastEventState = eventData.state;
      this.handleAmpDestroy();
    });

    this.subscriptions.push(loadeddata$);
    this.subscriptions.push(mutechange$);
    this.subscriptions.push(mediachange$);
    this.subscriptions.push(destroy$);
    this.subscriptions.push(autoplayblocked$);
    this.subscriptions.push(captionCueChange$);
  }
  initOmnitureTracking() {
    this.destroyOmnitureTracking();
    debug.log("[StreamingVideoPlayer] Init Omniture Tracking");
    let { amp, trackingSettings, playerSettings } = this;
    let omnitureTracking = new OmnitureTracking(
      trackingSettings,
      amp,
      playerSettings
    );
    omnitureTracking.init();
    this.omnitureTracking = omnitureTracking;
  }
  initMediaAnalyticsTracking() {
    this.destroyMediaAnalyticsTracking();
    let { amp, trackingSettings } = this;
    this.mediaAnalyticsTracking = new MediaAnalyticsTracking(
      amp,
      trackingSettings
    );
    this.mediaAnalyticsTracking.init();
  }
  initTracking() {
    debug.log("[StreamingVideoPlayer] Init Tracking");
    this.initOmnitureTracking();
    this.initMediaAnalyticsTracking();
  }
  setMedia(playerSettings) {
    debug.log(
      "[StreamingVideoPlayer] setMedia: playerSettings",
      playerSettings
    );
    this.playerSettings = playerSettings;
    let { amp, ampConfig } = this;
    amp.config.muted = amp.muted;
    debug.log(
      "[StreamingVideoPlayer] setMedia: ampConfig.media",
      ampConfig.media
    );
    amp.setMedia(ampConfig.media);
  }
}
